// extracted by mini-css-extract-plugin
export default {"wrap":"qI-z","subtitle":"rI-z","contentWrap":"sI-z","imgWrap":"tI-z","heading":"uI-z","copy":"vI-z"};